import INVENTORY_API_BASE_URL from "../../config/api";
import { useEffect, useState } from "react";
import axios from "axios";
import "./SalesReturn.css";

function SalesRetutn() {
  const [data, setData] = useState([]);
  const [orderNums, setOrderNums] = useState({});
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [popupData, setPopupData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [batchMapping, setBatchMapping] = useState({});
  const [selectedSKU, setSelectedSKU] = useState("");
  const [distributors, setDistributors] = useState([]);
  const [selectedDistributor, setSelectedDistributor] = useState("All");
  const [searchSKU, setSearchSKU] = useState("");
  const groupedData = {};
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [detailPopup, setDetailPopup] = useState({
    show: false,
    details: [],
    sku: "",
  });

  const [returnSummary, setReturnSummary] = useState([]);

  useEffect(() => {
    setCurrentPage(1);
  }, [startDate, endDate]);

  useEffect(() => {
    const fetchReturnSummary = async () => {
      try {
        const res = await axios.get(
          `${INVENTORY_API_BASE_URL}/distributor-sku-returns`
        );
        setReturnSummary(res.data);
      } catch (err) {
        console.error("Error fetching return summary:", err);
      }
    };

    fetchReturnSummary();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [shipmentRes, orderNumRes, batchidRes] = await Promise.all([
          axios.get(`${INVENTORY_API_BASE_URL}/selected-shipment-ids`),
          axios.get(`${INVENTORY_API_BASE_URL}/api/shipment/ordernums`),
          axios.get(
            `${INVENTORY_API_BASE_URL}/get-batchid-purchaseprice`
          ),
        ]);

        setData(shipmentRes.data);
        setOrderNums(orderNumRes.data.orderData || {});

        const mapping = {};
        batchidRes.data.data.forEach((entry) => {
          if (entry.batchid) {
            mapping[entry.batchid] = entry.purchasePrice;
          }
        });
        setBatchMapping(mapping);

        const distributorSet = new Set();
        shipmentRes.data.forEach((item) =>
          item.selectedShipmentIds.forEach((shipment) =>
            distributorSet.add(shipment.distributorName)
          )
        );
        setDistributors(["All", ...Array.from(distributorSet)]);

        setLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  if (loading) {
    return (
      <div className="salesreturn-container salesreturn-loading-page">
        <div className="spinner-container">
          <div className="circular-loader"></div>
          <div className="loading-text">Loading data, please wait...</div>
        </div>
      </div>
    );
  }

  const filteredData = data
    .map((item) => {
      const filteredShipments = (item.selectedShipmentIds || [])
        .map((shipment) => {
          const approvalDate = new Date(shipment.ApprovalDate);
          const isWithinDateRange =
            (!startDate || approvalDate >= new Date(startDate)) &&
            (!endDate || approvalDate <= new Date(endDate));

          const matchingQuantities = (shipment.updatedQuantity || []).filter(
            (qty) => qty?.sku?.toLowerCase().includes(searchSKU.toLowerCase())
          );

          if (
            (selectedDistributor === "All" ||
              shipment.distributorName === selectedDistributor) &&
            isWithinDateRange &&
            (searchSKU === "" || matchingQuantities.length > 0)
          ) {
            return {
              ...shipment,
              updatedQuantity: matchingQuantities,
            };
          }
          return null;
        })
        .filter(
          (shipment) => shipment !== null && shipment.updatedQuantity.length > 0
        );

      if (filteredShipments.length > 0) {
        return { ...item, selectedShipmentIds: filteredShipments };
      }
      return null;
    })
    .filter((item) => item !== null);

  const sortedData = [...filteredData].sort((a, b) => {
    const dateA = new Date(
      a.selectedShipmentIds?.[0]?.ApprovalDate || "1970-01-01"
    );
    const dateB = new Date(
      b.selectedShipmentIds?.[0]?.ApprovalDate || "1970-01-01"
    );
    return dateB - dateA;
  });

  const totalPages =
    selectedDistributor === "All"
      ? Math.ceil(sortedData.length / itemsPerPage)
      : 1;
  const currentData =
    selectedDistributor === "All"
      ? sortedData.slice(
          (currentPage - 1) * itemsPerPage,
          currentPage * itemsPerPage
        )
      : sortedData;

  const exportToCSV = (rows, filename = "sales_return.csv") => {
    if (!rows.length) return;
    const header = Object.keys(rows[0]).join(",");
    const csvContent =
      header +
      "\n" +
      rows
        .map((row) =>
          Object.values(row)
            .map((val) =>
              typeof val === "string" ? `"${val.replace(/"/g, '""')}"` : val
            )
            .join(",")
        )
        .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExport = () => {
    const exportRows = [];

    Object.entries(groupedData).forEach(([key, val]) => {
      const row = val.sampleRow;

      const approvedQty = val.approvedQtyTotal;
      const returnQty = row.returnQuantitySummary?.totalReturnQuantity || 0;
      const netQty = approvedQty - returnQty;

      exportRows.push({
        "Distributor Name": row.distributorName,
        SKU: row.sku,
        Title: row.title,
        Medium: row.Medium,
        Edition: row.edition,
        MRP: row.mrp,
        "Sales Price": row.PurchaseValue,
        "Printing Cost Value": val.printingCostTotal.toFixed(2),
        "Gross Sales Qty": approvedQty,
        "Total Sales Value":(row.PurchaseValue * approvedQty).toFixed(2),
      });
    });

    exportToCSV(exportRows);
  };

  filteredData.forEach((item) => {
    item.selectedShipmentIds.forEach((shipment) => {
      shipment.updatedQuantity.forEach((qty) => {
        const key = `${qty.sku}-${qty.title}`;
        const matchingOrderNum = Object.keys(orderNums).find(
          (orderNum) =>
            String(orderNum).trim() === String(shipment?.shipmentid).trim()
        );
        const scannedDataList = matchingOrderNum
          ? orderNums[matchingOrderNum]
          : [];

        const calculateTotal = (barcodes, sku) => {
          const batchCounts = {};
          barcodes.forEach((barcode) => {
            if (!barcode.startsWith(sku)) return;
            const batch = barcode.split("-").slice(0, 3).join("-");
            if (batch && batchMapping[batch]) {
              if (!batchCounts[batch]) batchCounts[batch] = new Set();
              batchCounts[batch].add(barcode);
            }
          });
          let total = 0;
          for (const [batch, set] of Object.entries(batchCounts)) {
            total += batchMapping[batch] * set.size;
          }
          return total.toFixed(2);
        };

        const printingCost = scannedDataList.length
          ? calculateTotal(scannedDataList, qty.sku)
          : 0;

        const matchedReturn = returnSummary.find(
          (ret) =>
            ret.Distributor === shipment.distributorName && ret.SKU === qty.sku
        );

        if (!groupedData[key]) {
          groupedData[key] = {
            approvedQtyTotal: 0,
            printingCostTotal: 0,
            sampleRow: {
              shipmentid: shipment.shipmentid,
              ApprovalDate: shipment.ApprovalDate,
              distributorName: shipment.distributorName,
              ...qty,
              returnQuantitySummary: matchedReturn || null,
            },
            scannedDataList,
            detailBreakdown: [],
          };
        }

        groupedData[key].approvedQtyTotal += Number(qty.approvedquantity);
        groupedData[key].printingCostTotal += Number(printingCost);
        groupedData[key].detailBreakdown.push({
          shipmentid: shipment.shipmentid,
          approvedquantity: qty.approvedquantity,
        });
      });
    });
  });

  const getTooltip = (colIndex, row, val) => {
  switch (colIndex) {
    case 7:
      return `Printing Cost Value = ∑ (Batch purchase price × barcode count) for SKU: ${row.sku}`;
    case 8:
      return `Gross Sales Quantity = Total sold quantity (sum of all shipment records)`;
    default:
      return typeof val === "string" ? val.replace(/₹/g, "") : val;
  }
};

  return (
    <div className="salesreturn-container">
      <main className="salesreturn-content">
        <header className="salesreturn-hero">
          <div className="salesreturn-hero-copy">
            <span className="salesreturn-eyebrow">SALES / DISTRIBUTORS</span>
            <h1>Distributor sales by SKU</h1>
            <p>Review shipped quantities, sales value, and printing cost by distributor.</p>
          </div>
          <div className="salesreturn-hero-summary">
            <span className="salesreturn-summary-icon" aria-hidden="true">↗</span>
            <span>
              <strong>{filteredData.length.toLocaleString()} matching records</strong>
              <small>Based on the selected filters</small>
            </span>
          </div>
        </header>

        <section className="salesreturn-metrics" aria-label="Sales return summary">
          <article className="salesreturn-metric">
            <span>SKU and title groups</span>
            <strong>{Object.keys(groupedData).length.toLocaleString()}</strong>
            <small>In the current filtered results</small>
          </article>
          <article className="salesreturn-metric salesreturn-metric--blue">
            <span>Gross sales quantity</span>
            <strong>{Object.values(groupedData).reduce((sum, item) => sum + Number(item.approvedQtyTotal || 0), 0).toLocaleString()}</strong>
            <small>Across matching shipments</small>
          </article>
          <article className="salesreturn-metric salesreturn-metric--green">
            <span>Distributors</span>
            <strong>{new Set(filteredData.flatMap((item) => item.selectedShipmentIds.map((shipment) => shipment.distributorName))).size.toLocaleString()}</strong>
            <small>Included in this view</small>
          </article>
          <article className="salesreturn-metric salesreturn-metric--violet">
            <span>Shipment groups</span>
            <strong>{filteredData.reduce((sum, item) => sum + item.selectedShipmentIds.length, 0).toLocaleString()}</strong>
            <small>Matching shipment records</small>
          </article>
        </section>

        <section className="salesreturn-filter-card" aria-labelledby="salesreturn-filter-title">
          <div className="salesreturn-section-heading">
            <div>
              <span className="salesreturn-section-kicker">REFINE THE REPORT</span>
              <h2 id="salesreturn-filter-title">Sales filters</h2>
            </div>
            <button type="button" className="salesreturn-clear-button" onClick={() => {
              setStartDate("");
              setEndDate("");
            }}>
              Clear dates
            </button>
          </div>

          <div className="salesreturn-filter-grid">
            <label className="salesreturn-filter-field salesreturn-filter-field--wide" htmlFor="salesreturn-distributor">
              <span>Distributor</span>
              <select id="salesreturn-distributor" value={selectedDistributor} onChange={(e) => {
                setSelectedDistributor(e.target.value);
                setCurrentPage(1);
              }}>
                <option value="All">All distributors</option>
                {distributors.map((d, i) => <option key={i} value={d}>{d}</option>)}
              </select>
            </label>
            <label className="salesreturn-filter-field salesreturn-filter-field--search" htmlFor="salesreturn-sku">
              <span>Search SKU</span>
              <input id="salesreturn-sku" type="text" value={searchSKU} onChange={(e) => setSearchSKU(e.target.value)} placeholder="Enter a SKU" />
            </label>
            <label className="salesreturn-filter-field" htmlFor="salesreturn-start-date">
              <span>Approval date from</span>
              <input id="salesreturn-start-date" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
            </label>
            <label className="salesreturn-filter-field" htmlFor="salesreturn-end-date">
              <span>Approval date to</span>
              <input id="salesreturn-end-date" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
            </label>
            <button type="button" className="salesreturn-export-button" onClick={handleExport}>
              <span aria-hidden="true">↓</span> Export CSV
            </button>
          </div>
        </section>

        <section className="salesreturn-table-card" aria-labelledby="salesreturn-table-title">
          <div className="salesreturn-table-heading">
            <div>
              <span className="salesreturn-section-kicker">SHIPMENT DETAIL</span>
              <h2 id="salesreturn-table-title">Sales by SKU</h2>
              <p>Printing cost is calculated from scanned barcodes and batch purchase prices.</p>
            </div>
            <span className="salesreturn-result-count">{Object.keys(groupedData).length.toLocaleString()} SKU groups</span>
          </div>
          <div className="salesreturn-table-scroll">
            <table className="salesreturn-table">
              <thead>
                <tr>
                  {["Distributor Name", "SKU", "Title", "Medium", "Edition", "MRP", "Sales Price", "Printing Cost Value", "Gross Sales Qty", "Total Sales Value"].map((header) => <th key={header}>{header}</th>)}
                </tr>
              </thead>
              <tbody>
  {(() => {
    const groupedData = {};

    currentData.forEach((item) => {
      item.selectedShipmentIds.forEach((shipment) => {
        shipment.updatedQuantity.forEach((qty) => {
          const key = `${qty.sku}-${qty.title}`;
          const matchingOrderNum = Object.keys(orderNums).find(
            (orderNum) =>
              String(orderNum).trim() === String(shipment?.shipmentid).trim()
          );
          const scannedDataList = matchingOrderNum
            ? orderNums[matchingOrderNum]
            : [];

          const calculateTotal = (barcodes, sku) => {
            const batchCounts = {};
            barcodes.forEach((barcode) => {
              if (!barcode.startsWith(sku)) return;
              const batch = barcode.split("-").slice(0, 3).join("-");
              if (batch && batchMapping[batch]) {
                if (!batchCounts[batch]) batchCounts[batch] = new Set();
                batchCounts[batch].add(barcode);
              }
            });
            let total = 0;
            for (const [batch, set] of Object.entries(batchCounts)) {
              total += batchMapping[batch] * set.size;
            }
            return total.toFixed(2);
          };

          const printingCost = scannedDataList.length
            ? calculateTotal(scannedDataList, qty.sku)
            : 0;

          const matchedReturn = returnSummary.find(
            (ret) =>
              ret.Distributor === shipment.distributorName &&
              ret.SKU === qty.sku
          );

          if (!groupedData[key]) {
            groupedData[key] = {
              approvedQtyTotal: 0,
              printingCostTotal: 0,
              sampleRow: {
                shipmentid: shipment.shipmentid,
                ApprovalDate: shipment.ApprovalDate,
                distributorName: shipment.distributorName,
                ...qty,
                returnQuantitySummary: matchedReturn || null,
              },
              scannedDataList,
              detailBreakdown: [],
            };
          }

          groupedData[key].approvedQtyTotal += Number(qty.approvedquantity);
          groupedData[key].printingCostTotal += Number(printingCost);
          groupedData[key].detailBreakdown.push({
            shipmentid: shipment.shipmentid,
            approvedquantity: qty.approvedquantity,
            approvalDate: shipment.ApprovalDate,
          });
        });
      });
    });


    return (
      <>

        {Object.entries(groupedData).map(([key, val], i) => {
          const row = val.sampleRow;
          const approvedQty = val.approvedQtyTotal;
          const returnQty =
            row.returnQuantitySummary?.totalReturnQuantity || 0;
          const netQty = approvedQty - returnQty;





          const cells = [
            row.distributorName,
            row.sku,
            <span className="salesreturn-title-cell">
              {row.title}
            </span>,
            row.Medium,
            row.edition,
            row.mrp,
            row.PurchaseValue,
            `₹${val.printingCostTotal.toFixed(2)}`,
            approvedQty,
            `₹${(row.PurchaseValue*approvedQty).toFixed(2)}`
          ];

          return (
            <tr key={i}>
              {cells.map((val, j) => (
                <td
                  key={j}
                  title={getTooltip(j, row, val)}
                  style={{
                    padding: "6px",
                    border: "1px solid #ddd",
                    fontSize: "13px",
                    textAlign: "center",
                  }}
                >
                  {val}
                </td>
              ))}
            </tr>
          );
        })}
      </>
    );
  })()}
</tbody>
            </table>
            {currentData.length === 0 && (
              <div className="salesreturn-empty-state">
                <strong>No sales records found</strong>
                <span>Try changing the distributor, SKU, or approval date filters.</span>
              </div>
            )}
          </div>

          {selectedDistributor === "All" && (
            <nav className="salesreturn-pagination" aria-label="Sales results pages">
              <button type="button" onClick={handlePrev} disabled={currentPage === 1}>Previous</button>
              <span>Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong></span>
              <button type="button" onClick={handleNext} disabled={currentPage === totalPages}>Next</button>
            </nav>
          )}
        </section>
      </main>

      {showPopup && (
        <div className="salesreturn-modal-backdrop" role="presentation">
          <section className="salesreturn-modal" role="dialog" aria-modal="true" aria-labelledby="salesreturn-batch-modal-title">
            <header className="salesreturn-modal-heading">
              <div>
                <span className="salesreturn-section-kicker">COST BREAKDOWN</span>
                <h2 id="salesreturn-batch-modal-title">Purchase price by batch</h2>
              </div>
              <span className="salesreturn-modal-sku">{selectedSKU || "SKU"}</span>
            </header>
            <ul className="salesreturn-batch-list">
              {Object.entries(popupData.reduce((acc, barcode) => {
                if (!barcode.startsWith(selectedSKU)) return acc;
                const parts = barcode.split("-");
                const batch = parts.length >= 3 ? parts.slice(0, 3).join("-") : null;
                if (batch && batchMapping[batch]) {
                  if (!acc[batch]) acc[batch] = { price: batchMapping[batch], count: 0 };
                  acc[batch].count += 1;
                }
                return acc;
              }, {})).map(([batch, { price, count }]) => (
                <li key={batch}>
                  <strong>{batch}</strong>
                  <span>{count} barcode{count === 1 ? "" : "s"} × ₹{price}</span>
                  <b>₹{(price * count).toFixed(2)}</b>
                </li>
              ))}
            </ul>
            <footer className="salesreturn-modal-footer">
              <button type="button" onClick={() => setShowPopup(false)}>Close</button>
            </footer>
          </section>
        </div>
      )}

      {detailPopup.show && (
        <div className="salesreturn-modal-backdrop" role="presentation" onClick={() => setDetailPopup({ show: false, details: [], sku: "" })}>
          <section className="salesreturn-modal" role="dialog" aria-modal="true" aria-labelledby="salesreturn-detail-modal-title" onClick={(e) => e.stopPropagation()}>
            <header className="salesreturn-modal-heading">
              <div>
                <span className="salesreturn-section-kicker">ORDER HISTORY</span>
                <h2 id="salesreturn-detail-modal-title">Sales quantity details</h2>
              </div>
              <span className="salesreturn-modal-sku">{detailPopup.sku}</span>
            </header>
            <div className="salesreturn-detail-list">
              {detailPopup.details.map((item, index) => (
                <article key={index}>
                  <div><span>Order ID</span><strong>{item.shipmentid}</strong></div>
                  <div><span>Sell quantity</span><strong>{item.approvedquantity}</strong></div>
                  <div><span>Order date</span><strong>{item.approvalDate}</strong></div>
                </article>
              ))}
            </div>
            <footer className="salesreturn-modal-footer">
              <button type="button" onClick={() => setDetailPopup({ show: false, details: [], sku: "" })}>Close</button>
            </footer>
          </section>
        </div>
      )}
    </div>
  );
}

export default SalesRetutn;
